<template>
    <div :key="$store.state.currentStepIndex" class="summary-content-wrapper">
        <div class="row thankyou" v-show="step.renderThankYou">
            <div role="status" class="col-12" v-html="$store.state.thankYouHtml">

            </div>
        </div>
        <div>
            <div class="summary-content" :class="{ lighter: step.renderThankYou}">
                <ContentHeadline>Zusammenfassung</ContentHeadline>
                <div class="row" v-for="(step) in $store.state.steps">
                    <div class="col-12" v-for="(summaryEntry, index) in step.summary">
                        <div class="row pb-3">
                            <div class="col-12 col-lg-4 summary-point fw-bold">
                              <a href="#" @click.prevent="clickEdit(step.index)" class="color-inherit"><i
                                class="fa-fw action-icon"
                                    :class="{
                                      [$store.state.faClass]: true,
                                      'fa-edit': !summaryEntry.noEdit,
                                      'fa-eye': summaryEntry.noEdit,
                                      'text-nowrap': summaryEntry.label.length < 25,
                                    }" style="cursor: pointer;"
                                  :aria-label="summaryEntry.noEdit ? 'anzeigen: ' : 'bearbeiten: '"
                                ></i>
                                <span v-if="summaryEntry.label.endsWith('?')">{{summaryEntry.label}}</span>
                                <span v-else>{{summaryEntry.label}}:</span>
                              </a>
                            </div>
                            <div class="col-12 col-lg-8" v-html="summaryEntry.text">{{summaryEntry.text}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-show="!step.renderThankYou">
                <div class="row mt-5">
                    <div class="col-12">
                        <ContentHeadline>Datenverarbeitung</ContentHeadline>
                        <div class="form-group form-check"
                             :class="{ 'is-invalid': validation.dataProcessingConsent.hasError}">
                            <input id="mf6_processing_agreement"
                                   type="checkbox"
                                   required
                                   class="form-check-input"
                                   :class="{ 'is-invalid': validation.dataProcessingConsent.hasError}"
                                   v-model="step.dataProcessingConsent"
                                   @change="handleDataProcessingConsent()"
                            >
                            <label class="form-check-label" for="mf6_processing_agreement"
                                   v-html="step.dataProcessingConsentHtml"></label>
                            <div class="invalid-feedback">
                                Wir benötigen Ihre Einwilligung, um Ihre Daten verarbeiten zu dürfen.
                            </div>
                        </div>
                    </div>
                </div>

                <div class="alert alert-warning" v-if="$store.state.steps.contact._email">
                    <div class="mb-3">Abschließend überprüfen Sie bitte Ihre E-Mail-Adresse:</div>

                    <span class="d-inline-block me-3" style="font-size: 1.5em">{{ $store.state.steps.contact._email }}</span>
                    <button type="button" class="btn btn-sm btn-outline-danger" @click.prevent="clickEdit(contactStepIndex)" >
                        <i :class="`${$store.state.faClass} fa-edit`"></i> ändern
                    </button>
                </div>

<!--                <div class="row mt-5">-->
<!--                    <h3 class="col-12">Absenden</h3>-->
<!--                </div>-->
<!--                <div class="row">-->
<!--                    <div class="col-12 form-group" :class="{ 'is-invalid': captchaError}">-->
<!--                        <vue-recaptcha class="captcha" :class="{ error: captchaError}" @verify="onVerify"-->
<!--                                       @expired="onExpired" :sitekey="$store.state.siteKey"-->
<!--                                       v-on:render="captchaRender"-->
<!--                        ></vue-recaptcha>-->
<!--                        <div class="invalid-feedback" v-show="captchaError && !captchaVerified">-->
<!--                            Bitte bestätigen Sie die Sicherheitsabfrage, um Sie und uns vor unerwünschter Werbung zu-->
<!--                            schützen.-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->

                <div class="mt-5 p-3 border border-warning form-element-bg" v-if="$store.state.debug.enabled">
                    <div class="row">
                        <ContentHeadline class="col-12">Testing</ContentHeadline>
                    </div>
                    <div data-toggle="buttons">
                        <label class="btn btn-primary">
                            <input type="radio" name="_ulmo_mode" autocomplete="off" value="bounce_test" checked>
                            Absender = Empfänger (Test-Mode)
                        </label>
                        <label class="btn btn-secondary">
                            <input type="radio" name="_ulmo_mode" autocomplete="off" value="">
                            in Ulmo konfigurierter Empfänger
                        </label>
                    </div>

                    <div class="form-group row mt-3">
                        <div class="col-12">
                            <button class="btn btn-outline-info" @click="preview">Vorschau (ohne Absenden)</button>
                        </div>
                    </div>
                </div>

                <div class="form-group row">
                    <div class="col-12 mt-5 mb-4">
                        <!-- :disabled="!captchaVerified" -->
                        <div class="alert alert-warning" role="alert" v-show="showNextDisabledHint">
                            {{$store.state.i18n.btnNextDisabledText}}
                        </div>
                        <button type="submit" @click="submit" class="btn btn-dark btn-block btn-lg next">
                            {{$store.state.i18n.submit}}
                        </button>
                        <div class="btn-subtext text-center pt-1">{{$store.state.i18n.btnSubmitSubtext}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    import VueRecaptcha from 'vue-recaptcha';
    import ContentHeadline from "./partials/ContentHeadline.vue";

    export default {
        props: ['step'],
        components: {ContentHeadline, VueRecaptcha},

        data() {
            return {
                showNextDisabledHint: false,
                validation: {
                    dataProcessingConsent: {hasError: false, message: 'Eingabe unvollständig/ungültig'},
                },
                retryCount: 0,
                captchaVerified: false,
                captchaError: false
            };
        },
        computed: {
            contactStepIndex() {
                return Object.keys(this.$store.state.steps).findIndex(
                    (key) => key === "contact"
                );
            },
        },
        methods: {
            clickEdit(index) {
                this.$store.state.currentStepIndex = index;
            },
            setError(type) {
                // console.log('setError', type);
                this.validation[type].hasError = true;
            },

            removeError(type) {
                this.showNextDisabledHint = false;
                // console.log('removeError', type);
                this.validation[type].hasError = false;
            },

            handleDataProcessingConsent() {
                const newValue = this.step.dataProcessingConsent ? this.step.dataProcessingConsentText : null;
                this.$store.commit('updateUserInput', {
                    name: 'legal[]',
                    module: this.step.type,
                    input: newValue
                });

                if (this.step.dataProcessingConsent) {
                    this.removeError('dataProcessingConsent');
                    return true;
                } else {
                    this.setError('dataProcessingConsent');
                    return false;
                }
            },

            captchaRender() {
                const int = setInterval(function () {
                    const $recaptchaElement = $('.g-recaptcha-bubble-arrow');
                    if ($recaptchaElement.length) {
                        clearInterval(int);
                        $recaptchaElement.parent().addClass('manet-g-recaptcha-root').addClass('manet-js-fix-width').css('width', 'auto').children().each(function(){
                            $(this).addClass('manet-js-fix-padding').css('padding', 0);
                        });
                    }
                }, 100);
            },

          /*
            validateCaptcha() {
                this.showNextDisabledHint = false;
                if (!this.captchaVerified) {
                    this.captchaError = true;
                    return false;
                }
                return true;
            },
            */

            validate() {
                this.showNextDisabledHint = false;
                this.step.wasValidated = true;
                const validations = [
                    this.handleDataProcessingConsent(),
                    // this.validateCaptcha(),
                ];
                // all true?
                return validations.every(v => v);
            },
            onVerify(response) {
                this.showNextDisabledHint = false;
                this.captchaVerified = true;
                this.captchaError = false;
                this.$store.commit('updateUserInput', {
                    name: 'g-recaptcha-response',
                    module: this.step.type,
                    input: response
                });
            },
/*            onExpired() {
                this.showNextDisabledHint = false;
                //recaptcha expired
                this.captchaVerified = false;
                this.captchaError = true;
                this.$store.commit('updateUserInput', {
                    name: 'g-recaptcha-response',
                    module: this.step.type,
                    input: null
                });
            },*/
            sendData(url, params) {
                const that = this;
                axios.post(url, params,
                    {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        }
                    })
                    .then(function (response) {
                        that.$store.commit('setLoading', false);
                        that.step.renderThankYou = true;
                        that.$store.commit('toggleNavigation', false);
                        that.$store.commit('setFormAsSent');
                        if (!that.$store.state.debug.enabled) {
                            window.dispatchEvent(new CustomEvent("manetform-thanks"));
                        }
                    })
                    .catch(function (error) {
                        // if (error.response && error.response.status == 400) {
                        //     console.error("server returned 400 (bad request), resetting captcha");
                        //     that.$store.commit('setLoading', false);
                        //     grecaptcha.reset();
                        //     that.onExpired();
                        //     return;
                        // }

                        if (that.retryCount < 2) {
                            setTimeout(function () {
                                that.sendData(url, params);
                                that.retryCount++;
                            }, 10000);

                        } else {
                            that.$store.commit('setLoaderText', {text: 'Hoppla! Da ist etwas schief gelaufen. '});
                            params.append('_error', error);
                            params.append('_url', url);
                            if (error.response) {
                                params.append('_status', error.response.status);
                                params.append('_headers', JSON.stringify(error.response.headers));
                            }
                            axios.post('/manet/form/errors', params, {
                                headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded'
                                }
                            }).then(function (response) {
                              that.$store.commit('setLoaderText', {append: true, text: '\nDer technische Support wurde informiert, bitte versuchen Sie es später erneut.'});
                            }).catch(function (error) {
                              that.$store.commit('setLoaderText', {append: true, text: '\nBitte informieren Sie den Support und versuchen Sie es später erneut.'});
                            });
                            that.$store.commit('setLoaderClosable', true);
                            that.retryCount = 0;
                        }
                    });
            },
            createParams(steps) {
                const params = new URLSearchParams();
                Object.keys(steps).forEach(function (key) {
                    const step = steps[key];
                    Object.entries(step.userInputs).forEach(([key, value]) => {
                        // console.log("key: ", key, "value: ", value, "typeof: ", typeof value)
                        if (Array.isArray(value)) {
                            value.forEach(i => params.append(key, i));
                        } else {
                            params.append(key, value);
                        }
                    });
                });

                const elementExists = document.querySelector("input[name='_ulmo_mode']:checked");
                if (elementExists) {
                    params.append('_ulmo_mode', elementExists.value);
                }
                params.append('subject', this.$store.state.subject);
                params.append('addr_1', this.$store.state.contact.name);
                params.append('addr_2', this.$store.state.contact.street);
                params.append('addr_3', this.$store.state.contact.zip + " " + this.$store.state.contact.place);
                // params.append('addr_4', );
                params.append('addr_tel', "Tel.: " + this.$store.state.contact.telephone);
                if (this.$store.state.contact.fax) {
                    params.append('addr_fax', "Fax: " + this.$store.state.contact.mail);
                }
                params.append('_form_vers', "6");

                return params;
            },
            submit(e) {
                e.preventDefault();

                if (!this.validate()) {
                    this.showNextDisabledHint = true;
                    return false
                }

                this.$store.commit('setLoading', true);

                const params = this.createParams(this.$store.state.steps);
                // const url = 'http://192.168.0.210:3010/jobs.json';
                // const url = 'https://anfrage.mvp.de/v3/cgi-bin/wel.cgi'; // captcha not required -> but returns html
                const url = 'https://anfrage.mvp.de/v3/jobs.json'; // captcha no longer required.

                this.sendData(url, params);
            },
            clickPrev(e) {
                this.$store.commit('setLastStep');
            },
            preview(e) {
                e.preventDefault();
                e.stopPropagation();
                const params = this.createParams(this.$store.state.steps);
                // window.open('https://anfrage.mvp.de/v3/backend/templates/f9?'+params.toString(),'_blank');
                window.open('https://anfrage.mvp.de/v3/backend/templates/1104?' + params.toString(), '_blank');
            }
        }
    }
</script>